import React from "react";
import Hero from "@/components/Hero";
import TrustCounters from "@/components/TrustCounters";
import Destinations from "@/components/Destinations";
import Packages from "@/components/Packages";
import WhyChoose from "@/components/WhyChoose";
import LuxuryCollections from "@/components/LuxuryCollections";
import Testimonials from "@/components/Testimonials";
import CtaBanner from "@/components/CtaBanner";
import { useNavigate } from "react-router-dom";
import { useLayout } from "@/components/Layout";

export default function Home() {
  const { openPlan } = useLayout();
  const navigate = useNavigate();

  return (
    <div data-testid="home-page">
      <Hero onPlanTrip={() => openPlan()} onExplore={() => navigate("/destinations")} />
      <TrustCounters />
      <Destinations onExplore={() => navigate("/destinations")} />
      <Packages onBook={(p) => openPlan({ destination: p.name })} />
      <WhyChoose />
      <LuxuryCollections onExplore={() => navigate("/luxury")} />
      <Testimonials />
      <CtaBanner onPlanTrip={() => openPlan()} />
    </div>
  );
}
